export const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
}

export const textAreaAutoSize = { minRows: 3, maxRows: undefined }

export const submitButtonLayoutProps = {
  wrapperCol: { offset: 8, span: 16 },
  className: 'text-right',
}

export const fullItemLayoutProps = {
  wrapperCol: { offset: 0, span: 24 },
}

export const defaultPagination = {
  defaultPageSize: 100,
  totalBoundaryShowSizeChanger: 10,
}

export const statisticPagination = {
  defaultPageSize: 100,
  pageSizeOptions: ['10', '20', '50', '100', '200', '500', '1000'],
  totalBoundaryShowSizeChanger: 10,
  position: ['bottomCenter' as const],
  size: 'default' as const,
}

export const letterRecipientsPagination = {
  defaultPageSize: 100,
  totalBoundaryShowSizeChanger: 100,
  position: ['bottomCenter' as const],
  hideOnSinglePage: true,
}

export const densePagination = {
  defaultPageSize: 5,
  totalBoundaryShowSizeChanger: 5,
  position: ['bottomCenter' as const],
  hideOnSinglePage: true,
}

export const sparsePagination = {
  defaultPageSize: 50,
  totalBoundaryShowSizeChanger: 10,
  position: ['bottomCenter' as const],
  size: 'default' as const,
}

export const tablePagination = {
  defaultPageSize: 10,
  totalBoundaryShowSizeChanger: 10,
  position: ['bottomCenter' as const],
  size: 'default' as const,
}

export const tablePaginationHiding = {
  defaultPageSize: 10,
  hideOnSinglePage: true,
  totalBoundaryShowSizeChanger: 10,
  position: ['bottomCenter' as const],
}

export const validateTrigger = ['onSubmit', 'onBlur']
export const clickTrigger = ['click' as const]

export const doubleColLayout = {
  xs: { span: 24 },
  xxl: { span: 12 },
}

export const bulkEditTransition = {
  enter: 'transition-all ease-in-out duration-300 origin-top',
  enterFrom: 'transform opacity-0 overflow-clip h-0',
  enterTo: 'transform opacity-100 overflow-clip h-8',
  leave: 'transition ease-in-out duration-300 origin-top',
  leaveFrom: 'transform opacity-100 overflow-clip h-8',
  leaveTo: 'transform opacity-0 overflow-clip h-0',
}

export const unitPriceEstimateTitlePrefix = 'Cenový odhad bytu č. '
export const areaPriceEstimateTitlePrefix = 'Cenový odhad: '
export const buildingPriceEstimateTitlePrefix = 'Cenový odhad pro '

export const cadastreMapMaxResultCount = 100000
export const monitoringInputLimit = 30000
export const isHugeSubjectLimit = 10000
export const cuzkOsInstantCheckLimit = 6
export const ceeInstantCheckLimit = 8
export const tooltipHelpUnderline =
  'underline decoration-dashed decoration-gray-500 underline-offset-4 cursor-help hover:text-primary hover:decoration-slate-400 transition-colors'

export const priceEstimateSummaryStyle =
  'text-right text-gray-400 !border-b-0 border-gray-100 border-t'

export const monitoringTilesStyle =
  'mt-2 grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 4xl:grid-cols-5 gap-y-8 gap-x-6'

export const imageSkeleton =
  'data:image/png;base64,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'

export const propertyDetailTableProps = {
  bordered: false,
  size: 'small' as const,
  pagination: {
    defaultPageSize: 10,
    totalBoundaryShowSizeChanger: 10,
    hideOnSinglePage: true,
    style: { marginTop: '2px' },
    position: ['bottomCenter' as const],
  },
}
export const alertWarningStyle = {
  backgroundColor: '#fff2c838',
  marginBottom: '24px',
}

export const propertyDrawerWrapperStyle = {
  styles: { wrapper: { maxWidth: '75%', width: '500px' } },
}
